(function(){
  function placeCare(){
    var story=document.querySelector('.product-template__container .mrak-product-story');
    if(!story)return false;
    var description=story.querySelector('.product-single__description');
    var care=document.querySelector('[data-mrak-product-care]');
    if(!description||!care)return false;
    care.classList.remove('page-width');
    if(care.previousElementSibling!==description){
      description.insertAdjacentElement('afterend',care);
    }
    return true;
  }
  function init(){placeCare();}
  if(!placeCare()){
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
    else window.requestAnimationFrame(init);
  }
  document.addEventListener('shopify:section:load',function(){window.requestAnimationFrame(init);});
})();
